import React, { useEffect, useRef, useState } from "react";
import { Badge, Tooltip } from "antd";
import { BellOutlined, ExclamationCircleFilled, ClockCircleFilled } from "@ant-design/icons";
import { getSubscriptionAlert } from "../../utils/subscription";
import "./SubscriptionBell.css";

const SubscriptionBell = ({ renewDate }) => {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    const alert = getSubscriptionAlert(renewDate);

    // Close on outside click
    useEffect(() => {
        const onClick = (e) => {
            if (ref.current && !ref.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", onClick);
        return () => document.removeEventListener("mousedown", onClick);
    }, []);

    // No warning — render nothing
    if (!alert) return null;

    const { tone, title, body, days } = alert;
    const isExpired = days < 0;
    const isUrgent = !isExpired && days <= 3;

    return (
        <div className="sub-bell" ref={ref}>
            <Tooltip title={title} placement="bottom">
                <button
                    type="button"
                    className={`sub-bell-btn ${open ? "is-open" : ""}`}
                    onClick={() => setOpen((v) => !v)}
                    aria-label="Subscription alert"
                    aria-expanded={open}
                >
                    <Badge dot={true} offset={[-2, 2]} color={tone === "danger" ? "#ef4444" : "#f59e0b"}>
                        <BellOutlined />
                    </Badge>
                </button>
            </Tooltip>

            {open && (
                <div className={`sub-bell-dropdown sub-bell-dropdown-${tone}`}>
                    <div className="sub-bell-icon">
                        {isExpired || isUrgent ? (
                            <ExclamationCircleFilled />
                        ) : (
                            <ClockCircleFilled />
                        )}
                    </div>
                    <div className="sub-bell-body">
                        <div className="sub-bell-title">{title}</div>
                        <div className="sub-bell-desc">{body}</div>
                        {!isExpired && renewDate && (
                            <div className="sub-bell-date">
                                Valid until{" "}
                                <strong>
                                    {new Date(renewDate).toLocaleDateString(
                                        undefined,
                                        {
                                            day: "numeric",
                                            month: "short",
                                            year: "numeric",
                                        }
                                    )}
                                </strong>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default SubscriptionBell;